// extracted by mini-css-extract-plugin
export var externalLink = "_d6-0";
export var internalLinkLabel = "_d6-1";